import { ReactNode } from 'react';
import { DocLink } from '../../docs/DocLink/DocLink';
import { TemplateRawFormFieldHelperText } from '../interfaces/template-raw-form';

export function TemplateFormHelperText({
  helperText,
  fieldName
}: {
  helperText?: TemplateRawFormFieldHelperText;
  fieldName: string;
}): ReactNode {
  if (!helperText || !helperText.text) {
    return null;
  }

  if (!helperText.doc_link) {
    return helperText.text;
  }

  const dataId = `template-form-${fieldName}-helper-text`;

  return (
    <span data-id={dataId}>
      {helperText.text}
      &nbsp;
      <DocLink
        docLink={helperText.doc_link.url}
        dataId={dataId}
        section={dataId}
        label={helperText.doc_link.title}
        icon={helperText.doc_link.icon}
      />
    </span>
  );
}
